<div mat-dialog-title>{{'administration.modal.title' | translate}}</div>
@if (!loading) {
  <div>
    @if (!deleteError && !deleteSuccess) {
      <mat-dialog-content>
        {{'administration.modal.remove_list' | translate : {name: diffList.name.toUpperCase()} }}
      </mat-dialog-content>
      <mat-dialog-actions>
        <button class="btn btn--outline-grey-color mr-20" mat-dialog-close>{{'action.cancel' | translate}}</button>
        <button class="btn btn--danger" (click)="deleteDiffusionList()">{{'action.delete_diffusion_list' | translate}}</button>
      </mat-dialog-actions>
    } @else {
      @if (deleteSuccess) {
        <div>
          <div class="alert alert-success">
            {{deleteSuccess}}
          </div>
          <mat-dialog-actions>
            <button class="btn btn--primary" [mat-dialog-close]="true"
            routerLink="/admin/list/table">{{'badges.delete.modal.return_list' | translate}}</button>
          </mat-dialog-actions>
        </div>
      }
      @if (deleteError) {
        <div>
          <div class="alert alert-error">
            {{deleteError}}
          </div>
          <mat-dialog-actions>
            <button class="btn btn--outline-grey-color" mat-dialog-close>{{'action.cancel' | translate}}</button>
          </mat-dialog-actions>
        </div>
      }
    }
  </div>
}
<span class="ui-loading" [model]="{isLoading: loading}"></span>
